import { Badge, Flex, FlexProps } from '@chakra-ui/react'
import {
  OrderLineStatus as OrderLineStatusEnum,
  OrderStatus as OrderStatusEnum,
} from 'api-client'
import React from 'react'

import { IconByName, IconNames } from '~shared-components/icons/brand'

import { useTranslations } from '../../hooks/useTranslations'
import { TFn } from '../../translations/translations'

export const getOrderStatusStyles = (
  t: TFn,
  status?: OrderLineStatusEnum | OrderStatusEnum,
): {
  color: string
  icon: IconNames
  text: string
} => {
  switch (status) {
    case OrderStatusEnum.Open:
      return {
        color: 'indigo.60',
        icon: 'IconTime',
        text: t('order.status.Open'),
      }
    case OrderStatusEnum.Closed:
      return {
        color: 'neutral.90',
        icon: 'IconCheckmark',
        text: t('order.status.Closed'),
      }
    case OrderLineStatusEnum.Acknowledged:
      return {
        color: 'yellow.50',
        icon: 'IconRocket',
        text: t('order.status.Acknowledged'),
      }
    case OrderLineStatusEnum.Confirmed:
      return {
        color: 'green.60',
        icon: 'IconCheckmark',
        text: t('order.status.Confirmed'),
      }
    case OrderLineStatusEnum.OutForDelivery:
      return {
        color: 'indigo.50',
        icon: 'IconTruck',
        text: t('order.status.OutForDelivery'),
      }
    case OrderLineStatusEnum.Invoiced:
      return {
        color: 'neutral.90',
        icon: 'IconCircleCheckmark',
        text: t('order.status.Invoiced'),
      }
    case OrderStatusEnum.Cancelled:
    case OrderLineStatusEnum.Cancelled:
      return {
        color: 'neutral.30',
        icon: 'IconClose',
        text: t('order.status.Cancelled'),
      }
    case OrderLineStatusEnum.Submitted:
    default:
      return {
        color: 'yellow.50',
        icon: 'IconTime',
        text: t('order.status.Submitted'),
      }
  }
}

interface OrderStatusProps extends FlexProps {
  status?: OrderStatusEnum
}
export const OrderStatus = ({ status, ...flexProps }: OrderStatusProps) => {
  const t = useTranslations()
  const { color, icon, text } = getOrderStatusStyles(t, status)
  return (
    <Flex alignItems="center" fontSize="md" {...flexProps}>
      <IconByName inverted boxSize="20px" fill={color} mr="10px" name={icon} />
      {text}
    </Flex>
  )
}

export const OrderLineStatus = ({
  status,
}: {
  status?: OrderLineStatusEnum
}) => {
  const t = useTranslations()
  const { color, text } = getOrderStatusStyles(t, status)
  return status ? (
    <Badge bg={color} color="white">
      {text}
    </Badge>
  ) : null
}
